import React from 'react'
import Widget from './Widget'
import styles from './WidgetPlaylist.module.css'

type Props = {
  coverSrc: string
  title: string
  subtitle?: string
  thumbs: [string, string, string, string]
  primaryColor: string
  secondColor: string
}

export default function WidgetPlaylist({ coverSrc, title, subtitle, thumbs, primaryColor, secondColor }: Props) {
  return (
    <Widget size="medium">
      <div className={styles.wrapper}>
        <div className={styles.top} style={{ backgroundColor: primaryColor }}>
          <div className={styles.header}>
            <div className={styles.left}>
              <img src={coverSrc} alt="" className={styles.cover} />
              <div className={styles.meta}>
                <div className={styles.title}>{title}</div>
                {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
              </div>
            </div>
            <img src="/images/icons/spotify.svg" alt="Spotify" className={styles.spotifyIcon} />
          </div>
        </div>

        <div className={styles.bottom} style={{ backgroundColor: secondColor }}>
          <div className={styles.grid}>
            <img src={thumbs[0]} alt="" className={styles.thumb} />
            <img src={thumbs[1]} alt="" className={styles.thumb} />
            <img src={thumbs[2]} alt="" className={styles.thumb} />
            <img src={thumbs[3]} alt="" className={`${styles.thumb} ${styles.maybeHide}`} />
          </div>
        </div>
      </div>
    </Widget>
  )
}
